import { ROUTE_IDS } from '../../experience/routes/ids.js';
import { COMMON_AVATAR_ROUTE_IDS } from './presets.js';
export const PLATFORM_USER_ACCESS_PROFILE = {
    persona: 'PLATFORM_USER',
    actorTypes: ['USER'],
    scope: {
        allowedKinds: ['SYSTEM', 'PLATFORM'],
        defaultKind: 'PLATFORM',
        organizationRequired: false,
        branchRequired: false,
        clientRequired: false,
        ownershipPolicy: 'PLATFORM',
    },
    authentication: {
        defaultAal: 'AAL1',
        administrationAal: 'AAL2',
    },
    navigation: {
        landingRouteId: ROUTE_IDS.DASHBOARD,
        primaryRouteIds: [ROUTE_IDS.DASHBOARD, ROUTE_IDS.REPORTS],
        avatarRouteIds: COMMON_AVATAR_ROUTE_IDS,
        structurallyDeniedRouteIds: [
            ROUTE_IDS.ADMIN_HUB,
            ROUTE_IDS.DATA_HUB,
            ROUTE_IDS.TRANSACTIONS,
            ROUTE_IDS.TRANSACTION_CREATE,
            ROUTE_IDS.TRANSACTION_APPROVALS,
            ROUTE_IDS.TRANSACTION_REVERSALS,
            ROUTE_IDS.HOLDINGS,
            ROUTE_IDS.RECONCILIATION,
            ROUTE_IDS.CORPORATE_ACTIONS,
            ROUTE_IDS.DATA_INSTRUMENTS,
            ROUTE_IDS.DATA_IMPORTS,
            ROUTE_IDS.DATA_RECONCILIATION,
            ROUTE_IDS.DATA_CORPORATE_ACTIONS,
            ROUTE_IDS.DATA_FACT_BATCHES,
            ROUTE_IDS.DATA_HOLDINGS,
            ROUTE_IDS.ORGANIZATION_USERS_LIST,
            ROUTE_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE,
            ROUTE_IDS.ORGANIZATION_ROLES_LIST,
            ROUTE_IDS.ORGANIZATION_PROFILE,
            ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
            ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
            ROUTE_IDS.PLATFORM_ACCESS_INSPECTOR,
            ROUTE_IDS.SETTINGS_MFA,
        ],
    },
    access: {
        defaultOperationBundleIds: ['platform-read'],
        allowedOperationBundleIds: ['platform-read'],
    },
    modules: {
        baseline: ['PLATFORM', 'AUTH', 'DASHBOARD', 'SETTINGS', 'NAVIGATION', 'REPORTING'],
        optional: [],
        forbidden: ['ADMIN', 'INVESTMENT', 'ACCOUNTING', 'TAX', 'RECONCILIATION', 'CORPORATE_ACTIONS', 'IMPORT', 'INSTRUMENTS', 'FACTS', 'HOLDINGS', 'MARGIN_TRADING', 'ORDER_MANAGEMENT', 'DATA'],
    },
    administration: {
        resourceIds: [],
    },
    context: {
        maySwitchOrganization: false,
        maySwitchBranch: false,
        maySelectClient: false,
        maySelectPortfolio: false,
    },
    delegation: {
        mayInitiate: false,
        mayReceive: false,
        organizationDataRequiresDelegation: true,
    },
    mutationPolicy: 'READ_ONLY',
};
